var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.29289 10.0406C5.68342 10.4311 6.31658 10.4311 6.7071 10.0406C7.09763 9.65008 7.09763 9.01691 6.70711 8.62639L5.29289 10.0406ZM2 5.3335L1.29289 4.62639L0.585787 5.3335L1.29289 6.0406L2 5.3335ZM6.7071 2.0406C7.09763 1.65008 7.09763 1.01691 6.7071 0.626388C6.31658 0.235864 5.68342 0.235864 5.29289 0.626389L6.7071 2.0406ZM6.70711 8.62639L2.70711 4.62639L1.29289 6.0406L5.29289 10.0406L6.70711 8.62639ZM2.70711 6.0406L6.7071 2.0406L5.29289 0.626389L1.29289 4.62639L2.70711 6.0406Z",
    fill: "#6251AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36328 4.3335C1.811 4.3335 1.36328 4.78121 1.36328 5.3335C1.36328 5.88578 1.811 6.3335 2.36328 6.3335L2.36328 4.3335ZM13.9996 6.3335C14.5519 6.3335 14.9996 5.88578 14.9996 5.3335C14.9996 4.78121 14.5519 4.3335 13.9996 4.3335L13.9996 6.3335ZM2.36328 6.3335L13.9996 6.3335L13.9996 4.3335L2.36328 4.3335L2.36328 6.3335Z",
    fill: "#6251AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.3bdfa4f08246c58d10e672731a74e128.svg";
export { ForwardRef as ReactComponent };